import * as React from 'react';
import { cn } from '../../utils';

interface OffsetHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: 1 | 2 | 3 | 4;
}

const sizeMap = {
  1: 'text-5xl',
  2: 'text-4xl',
  3: 'text-3xl',
  4: 'text-2xl',
} as const;

const OffsetHeading = React.forwardRef<HTMLHeadingElement, OffsetHeadingProps>(
  ({ level = 1, className, children, ...props }, ref) => {
    const Tag = `h${level}` as const;
    const text = typeof children === 'string' ? children : undefined;

    return (
      <Tag
        ref={ref}
        data-text={text}
        className={cn(
          'font-display leading-tight',
          sizeMap[level],
          text && 'riso-offset',
          className,
        )}
        {...props}
      >
        {children}
      </Tag>
    );
  },
);
OffsetHeading.displayName = 'OffsetHeading';

export { OffsetHeading };
